import ArrowForward from '@mui/icons-material/ArrowForward';

import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

import { BASE_STYLES } from '../utils/constants';

export const Root = superstyled({
  name: 'Article',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    ...BASE_STYLES,
    cursor: 'pointer',
    width: '100%',
    textDecoration: 'none',
    borderRadius: theme.shape.borderRadius,

    '&:hover': {
      transform: 'none',
      boxShadow: 'none'
    }
  })
});

export const Content = superstyled({
  name: 'Article',
  slot: 'Content',
  tag: CardContent,
  styles: ({ theme }) => ({
    padding: theme.spacing(3)
  })
});

export const Media = superstyled({
  name: 'Article',
  slot: 'Media',
  propsAdded: {
    component: 'figure'
  },
  styles: {
    position: 'relative'
  }
});

export const Image = superstyled({
  name: 'Article',
  slot: 'Image',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    alignSelf: 'center',
    borderRadius: theme.shape.borderRadius,
    aspectRatio: '1.6'
  })
});

export const ImagePlaceholder = superstyled({
  name: 'Article',
  slot: 'ImagePlaceholder',
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    aspectRatio: '1.6',
    backgroundColor: theme.palette.grey[100],
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(1),
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0'
  })
});

export const Header = superstyled({
  name: 'Article',
  slot: 'Header',
  tag: Box,
  styles: ({ theme }) => ({
    paddingBlock: theme.spacing(3, 1),
    gap: theme.spacing(1),
    display: 'flex',
    alignItems: 'baseline',
    flexDirection: 'column'
  })
});

export const HeaderContainer = superstyled({
  name: 'Article',
  slot: 'HeaderContainer',
  tag: Box,
  styles: () => ({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  })
});

export const SummaryContainer = superstyled({
  name: 'Article',
  slot: 'SummaryContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3)
  })
});
export const Summary = superstyled({
  name: 'Article',
  slot: 'Summary',
  tag: Text,
  styles: ({ theme }) => ({
    textTransform: 'uppercase',
    paddingTop: theme.spacing(3)
  })
});

export const Title = superstyled({
  name: 'Article',
  slot: 'Title',
  tag: Text,
  propsAdded: {
    size: 'lg'
  },
  styles: ({ theme }) => ({
    color: theme.palette.primary.main,
    // marginBottom: theme.spacing(2),
    lineHeight: 1.5,
    fontWeight: 600,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal'
  })
});

export const Description = superstyled({
  name: 'Article',
  slot: 'Description',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary,
    lineHeight: 1.5
  })
});

export const Meta = superstyled({
  name: 'Article',
  slot: 'Meta',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: 'auto'
  })
});

export const Author = superstyled({
  name: 'Article',
  slot: 'Author',
  tag: Text,
  propsAdded: {
    size: 'sm'
  },
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary,
    fontWeight: 500
  })
});

export const Date = superstyled({
  name: 'Article',
  slot: 'Date',
  tag: Text,
  propsAdded: {
    size: 'sm'
  },
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary
  })
});

export const Separator = superstyled({
  name: 'Article',
  slot: 'Separator',
  tag: Text,
  propsAdded: {
    size: 'sm'
  },
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary
  })
});

export const TextHighlight = superstyled({
  name: 'ArticleCard',
  slot: 'TextHighlight',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.secondary.main,
    fontWeight: 600
  })
});

export const ArrowForwardIcon = superstyled({
  name: 'ArticleCard',
  slot: 'ArrowForwardIcon',
  tag: ArrowForward,
  styles: ({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    color: theme.palette.secondary.main,
    transition: 'transform 0.3s ease',
    '.MuiButton-root:hover &': {
      transform: 'translateX(6px)'
    }
  })
});
